import { GroupMember } from "~/common/Store/models/ProductListing";
import getLowestPrice from "./getLowestPrice";
import isActiveSale from "./isActiveSale";
import itemHasMapStyle from "./itemHasMapStyle";
import applyBelowMapPricing from "./Pricing/applyBelowMapPricing";
import { User } from "~/common/Store/models/User";

export default (vgItem: GroupMember, user: User) => {
  const {
    price,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
  } = vgItem;

  const onSale = isActiveSale(price);
  const hasMapStyle = itemHasMapStyle(price, onSale);
  const applyBelowMapPrice = applyBelowMapPricing(
    {
      price,
      showBelowMinimumAdvertisedPriceForLoggedInCustomers,
      showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
    },
    user
  );

  const mapStyle = price.minimumAdvertisedPriceProperties.type;

  const mapStylesWithHiddenPrice = ["C", "E", "M", "P", "W"];

  let shouldDisplay = true;
  let lowestVisible = price.price;

  if (hasMapStyle && !applyBelowMapPrice) {
    if (mapStylesWithHiddenPrice.includes(mapStyle)) {
      shouldDisplay = false;
    }

    lowestVisible = Math.min(onSale ? price.salePrice : Infinity, price.price);
  } else {
    lowestVisible = getLowestPrice(
      price,
      user,
      false,
      showBelowMinimumAdvertisedPriceForLoggedInCustomers,
      showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
      true
    );
  }

  return {
    shouldDisplay,
    lowestVisible,
  };
};
